export enum EditingMode{
    Update = 'UPDATE',
    Create = 'CREATE',
    Delete = "DELETE",
    Off = "OFF"
}